var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification-card',{attrs:{"notifications":_vm.notifications},on:{"remove-notification":_vm.removeNotification}})
}
var staticRenderFns = []

export { render, staticRenderFns }